// extracted by mini-css-extract-plugin
export var editButton = "_nr-0";